import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

interface WarningProps {
  warningState?: boolean;
}

export const WarningText = styled.p<WarningProps>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) =>
    props.warningState
      ? props.theme.atlas.semantic.color.status.warning.default
      : props.theme.atlas.semantic.color.action.destructive.default};
  margin: 0;
`;

export const WarningContainer = styled.div<WarningProps>`
  display: flex;
  align-items: center;
  column-gap: 12px;
  margin-bottom: ${(props) =>
    props.warningState ? '0px' : `${props.theme.spacing(32)}px`};
`;
